<template>
  <div class="card mt-3">
    <div class="card-body">
      <h5 class="card-title">
        {{ trans("admin.cdr.verificationChecklist") }}
      </h5>

      <div class="form-check mb-2">
        <input
          id="verify-authorised"
          class="form-check-input"
          type="checkbox"
          checked
          disabled
        />
        <label class="form-check-label" for="verify-authorised">
          {{ trans("admin.cdr.verifyAuthorisedRepresentative") }}
        </label>
      </div>

      <div class="form-check mb-2">
        <input
          id="verify-identity"
          class="form-check-input"
          type="checkbox"
          checked
          disabled
        />
        <label class="form-check-label" for="verify-identity">
          {{ trans("admin.cdr.verifyIdentityValidated") }}
        </label>
      </div>

      <div class="form-check mb-3">
        <input
          id="verify-scope"
          class="form-check-input"
          type="checkbox"
          checked
          disabled
        />
        <label class="form-check-label" for="verify-scope">
          {{ trans("admin.cdr.verifyScopeDefinition") }}
        </label>
      </div>

      <div class="row">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.verifiedBy") }}:</strong>
          {{ verification.verified_by_name }}
        </div>
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.verifiedAt") }}:</strong>
          {{ verification.verified_at_formatted }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    verification: { type: Object, required: true },
  },
};
</script>
